import React, { useRef, useState, useEffect } from 'react'; // Importamos o useRef
import Footer from "../componentes/footer/footer";
import Header from "../componentes/header/header";
import './main.css';
import CardAvaliacao from "../componentes/card_avaliacao/card_avaliacao";
import { assets } from "../assets/assets";
import { Link } from 'react-router-dom';

const Main = () => {

  useEffect(() => {
    document.title = "Trinco | A sua loja de serviços";
  }, []);

  // Criamos a referência para a seção de serviços
  const servicosRef = useRef(null);

  // Função para executar a rolagem suave
  const scrollParaServicos = () => {
    servicosRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const listaAvaliacoes = [
    {
      id: 1,
      name: "Ivone Gusmão Silva",
      quote: "Fui consertar meus óculos 👓 atendimento rápido e eficaz",
      rating: 5,
    },
    {
      id: 2,
      name: "Rute Maria",
      quote: "Fica ali pertinho no Shopping Salvador Norte, pessoal super educado. Atendimento de primeira, pode confiar.",
      rating: 5,
    },
    {
      id: 3,
      name: "Marcelo Fraguas",
      quote: "Essa loja é referência para quem precisa de serviços de reparo em relógios.",
      rating: 4,
    },
    {
      id: 4,
      name: "Adriano Lazaro",
      quote: "Preço Justo para uma loja no shopping Center!",
      rating: 4,
    },
    {
      id: 5,
      name: "Alexandre Lima",
      quote: "Sempre bem atendido. Obrigado inclusive!",
      rating: 5,
    },
    {
      id: 6,
      name: "Vagner Cardoso",
      quote: "Atendimento de qualidade e super educados.",
      rating: 5,
    },
    {
      id: 7,
      name: "Andyara Chagas Coutinho",
      quote: "No quiosque da Trinco fomos bem atendidos e de forma célere, gostei bastante.",
      rating: 5,
    },
    {
      id: 8,
      name: "Jamile Carvalho",
      quote: "Excelente loja! Sempre me ajuda quando preciso",
      rating: 5,
    },
    {
      id: 9,
      name: "Jurilda Spínola",
      quote: "Excelente atendimento e cordialidade...fiz o pedido pelo Instagram e retirei o produto em loja...ótima experiência",
      rating: 5,
    },
    {
      id: 10,
      name: "Rodrigo Cunha",
      quote: "Grande variedade de produtos e serviços, bom atendimento, preços razoáveis.",
      rating: 5,
    },
    {
      id: 11,
      name: "Josi Costa",
      quote: "Atendimento excelente , bons profissionais. Super recomendo.",
      rating: 5,
    },
    {
      id: 12,
      name: "Genivaldo Santos",
      quote: "Profissionais com experiencia e responsabilidade. Empresa com mais de 20 anos no mercado.",
      rating: 4,
    },
  ];

  const AvaliacoesSection = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const totalPaginas = Math.ceil(listaAvaliacoes.length / 2);

    // Lógica para girar automaticamente
    useEffect(() => {
      const interval = setInterval(() => {
        setCurrentIndex((prev) => (prev === totalPaginas - 1 ? 0 : prev + 1));
      }, 6000); // 6 segundos para dar tempo de ler os dois

      return () => clearInterval(interval);
    }, [totalPaginas]);

    return (
      <div className="avaliacoes-container">
        <h2 className="avaliacoes-title">Avaliações</h2>

        <div className="review-carousel-wrapper">
          <div
            className="review-track"
            style={{ transform: `translateX(-${currentIndex * 100}%)` }}
          >
            {/* Mapeamos os itens em duplas ou apenas individuais com largura de 50% */}
            {listaAvaliacoes.map((review) => (
              <div key={review.id} className="review-slide-half">
                <div className="card-avaliacao-compacto">
                  <p className="review-quote">"{review.quote}"</p>
                  <h4 className="review-author">— {review.name}</h4>
                  <div className="review-stars">
                    {"★".repeat(review.rating)}
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="carousel-dots">
            {[...Array(totalPaginas)].map((_, idx) => (
              <span
                key={idx}
                className={`dot ${currentIndex === idx ? 'active' : ''}`}
                onClick={() => setCurrentIndex(idx)}
              ></span>
            ))}
          </div>
        </div>
      </div>
    );
  };

  const [emailNews, setEmailNews] = useState("");

  const handleNewsletter = (e) => {
    e.preventDefault();
    alert(`E-mail ${emailNews} cadastrado com sucesso!`);
    setEmailNews("");
  };


  return (
    <>
      <div className="main-page">
        <Header />

        {/* 1. HERO BANNER */}
        <section className="hero-banner">
          <div className="hero-overlay">
            <div className="hero-content">
              <h1>Os serviços que fazem parte da sua rotina.</h1>
              <p>A Trinco agora vai até você.</p>
              <button className="cta-button" onClick={scrollParaServicos}>Conheça nossos serviços</button>
            </div>
          </div>
        </section>

        {/* 2. O QUE FAZEMOS (Cards com Scroll) */}
        <section className="what-we-do" ref={servicosRef}>
          <div className="section-header">
            {/* <h2>Estamos aqui para ajudar com nossos serviços...</h2> */}
            <p className="section-subtitle">
              Descubra a variedade de serviços da Trinco, incluindo solda em joias, cópia de chaves, redução de pulseira e muito mais.
            </p>
          </div>

          {/* Container que permite o scroll */}
          <div className="services-scroll-wrapper">
            <div className="services-grid">

              <Link className="service-card" to='/servico_relogio'>
                <img src={assets.consertoRelogios} alt="Conserto de Relógios" className="service-img" />
                <div className="service-info">
                  <h3>Relógios</h3>
                  {/* <p>De clássicos a modernos, cuidamos do seu tempo.</p> */}
                </div>
              </Link>

              <Link className="service-card" to='/servico_joias'>
                <img src={assets.capaJoias} alt="Joias" className="service-img" />
                <div className="service-info">
                  <h3>Joias</h3>
                  {/*<p>Segurança e rapidez com tecnologia de ponta.</p>*/}
                </div>
              </Link>

              <Link className="service-card" to='/servico_oculos'>
                <img src={assets.reparoOculos} alt="Afiação" className="service-img" />
                <div className="service-info">
                  <h3>Óculos</h3>
                  {/*<p>Ajustes, soldas e substituição de peças para garantir o seu conforto visual. Devolvendo a forma e a resistência aos seus óculos</p>*/}
                </div>
              </Link>

              <Link className="service-card" to='/servico_celular'>
                <img src={assets.consertoCelular} alt="Assistência Celular" className="service-img" />
                <div className="service-info">
                  <h3>Celulares</h3>
                  {/*<p>Reparos rápidos para manter você conectado.</p>*/}
                </div>
              </Link>

              <Link className="service-card" to='/gravacao_laser'>
                <img src={assets.gravacaoLaser} alt="Afiação" className="service-img" />
                <div className="service-info">
                  <h3>Gravação a Laser</h3>
                  {/*<p>Personalização com precisão milimétrica em diversos materiais. Eternize nomes, logotipos e datas com acabamento impecável.</p>*/}
                </div>
              </Link>

              {/*   <Link className="service-card" to='/copia_chave'>
                <img src={assets.chavesYaleTetra} alt="Cópias de Chaves" className="service-img" />
                <div className="service-info">
                  <h3>Chaves</h3>
                  <p>Segurança e rapidez com tecnologia de ponta.</p>
            </div>
          </Link> */}

              <Link className="service-card" to='/servico_carimbos'>
                <img src={assets.confeccaoCarimbo} alt="Carimbos" className="service-img" />
                <div className="service-info">
                  <h3>Carimbos</h3>
                  {/*<p>Carimbos personalizados e automáticos prontos em poucos minutos. Precisão e durabilidade para facilitar a sua rotina profissional.</p>*/}
                </div>
              </Link>

            </div>
          </div >
        </section >

        <AvaliacoesSection />

        {/* 5. SHOP ONLINE */}
        < section className="find-store-section" >
          <Link className="store-card" to='/trinco_mais'>
            <div className="store-content">
              <h2>Trinco+</h2>
              <h2>Serviço de coleta e entrega</h2>
              <p>A Trinco vai até você.</p>
              <p>Comodidade, logística própria e o padrão Trinco de sempre.</p>
              <button className="store-button">Conheça mais</button>
            </div>
          </Link>
        </section >

        {/* 4. BANNER ENCONTRE A LOJA */}
        < section className="find-store-section" >
          <Link className="store-card" to='/nossas_lojas'>
            <div className="store-content">
              <h2>Encontre a loja mais próxima</h2>
              <p>Clique aqui e encontre uma de nossas lojas para atendê-lo</p>
              <button className="store-button">Procure</button>
            </div>
          </Link>
        </section >

        {/* Newsletter Centralizada embaixo ou ao lado */}
        < div className="newsletter-card full-width" >
          <h3>Novidades</h3>
          <p>Conteúdos, lançamentos e serviços em primeira mão.</p>
          <form onSubmit={handleNewsletter} className="newsletter-form">
            <input
              type="email"
              placeholder="Seu e-mail"
              value={emailNews}
              onChange={(e) => setEmailNews(e.target.value)}
              required
            />
            <button type="submit">Inscrever-se</button>
          </form>
        </div >

        <Footer />
      </div >
    </>
  )
}

export default Main;